import { Match, Redacted } from "effect";
import type { CanonicalJsonError } from "./model.ts";
import type { DigestInvocationError } from "../errors/digest.ts";

/** A receiving domain retains opaque input identity and the typed JSON refusal. */
export const canonicalJsonCause = (failure: CanonicalJsonError | DigestInvocationError): unknown => Match.value(failure).pipe(
  Match.tag("CanonicalJsonInputError", "DigestInvocationError", error => Redacted.value(error.cause)),
  Match.tag("CanonicalJsonFailure", error => error),
  Match.exhaustive
);
